import UnexpectedStockOutflow from '../../domain/UnexpectedStockOutflow'

export const getProducts = (repository) => {
  try {
    const products = repository.getDistinctProducts()
    return products
  } catch (error) {
    throw new Error(error.message || 'Error al obtener la lista de productos de salidas inesperadas')
  }
}